import { AuthDiagnostics } from "@/features/admin/auth-diagnostics";

export default function AdminAuthDiagnosticsPage() {
  return <AuthDiagnostics />;
}
